export { default } from "./DeleteAccountWrapper.jsx";
